import { render } from "./GameTickets.vue?vue&type=template&id=5ddb0088&scoped=true"
import script from "./GameTickets.vue?vue&type=script&lang=js"
export * from "./GameTickets.vue?vue&type=script&lang=js"

import "./GameTickets.vue?vue&type=style&index=0&id=5ddb0088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddb0088"]])

export default __exports__